module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUBJREFUeNrsVDFOw0AQdCx63FCTH+R+gPMCjESPU9PkCX4CFPSkRyL5gfmB84OjpjE/YA5mo9HpAidRgbzS6nS+253Z2T0XxWST/Teb/Sb47PbpFEsDn/PT9u3hep8Te5KZvKU7fn6Ee/gaXsn1Gr5EzDnWjnsjVYPUS1bFSHBJkCpThIbkusRZC+DNj8AAvSGomRf2hVTekJjdbbmOQrgH6FIDyyOgF5LIs4oxUcFKkjsB3VJms7sYo0yALhhorB0Hxsm1tcomwJ8q4OxK24P97ltggvYMGjkQ71FMmNx7ue9VeqqQGtD0c4p6aqB7OX9mPwsh546BEmyUfIPJHhQoc0BpnSSqBTRU3MSVUinrecUY88M7tmkdmOQ1liYQAcF59MPwiV5rzAYxvRCwl/AlNWUJFQyJnk422d+yDwEGACfWfLdSmbuQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/mar/58.png
// module id = 778
// module chunks = 0